module.exports = __webpack_public_path__ + "static/media/gif.d25a4074.gif";